import React, { useCallback, useRef, useState } from 'react';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import Input from '../../components/Input';
import Button from '../../components/Button';

import * as S from './styles';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
// import getValidationErrors from '../../utils/getValidationErrors';
import { useToast } from '../../hooks/toast';
import logo from '../../assets/logo-coach.png';

interface SignInFormData {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [showpass, setShowPass] = useState(false);
  const showPassword = () => setShowPass(!showpass);
  let navigate = useNavigate();
  const { signIn } = useAuth();

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      setShowPass(false);
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string().required('Usuario obrigatorio'),
          password: Yup.string().required('Senha obrigatorio'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoading(true);

        await signIn({
          email: data.email,
          password: data.password,
        });

        setLoading(false);
        navigate('/dashboard');
      } catch (err: any) {
        setLoading(false);
        // const errors = getValidationErrors(err);
        // formRef.current?.setErrors(errors);
        console.log(err);
        let errMsg: string = '';
        if (err.response.data) {
          errMsg = err.response.data?.message;
        } else {
          errMsg = err.message;
        }
        addToast({
          type: 'error',
          title: errMsg,
        });
      }
    },
    [signIn, navigate, addToast]
  );

  return (
    <S.Container>
      <div>
        <div>
          <div>
            <div>
              <S.Img src={logo} alt="logo" />
            </div>
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              placeholder={undefined}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            >
              <section>
                <Input name="email" icon={FiMail} placeholder="E-mail" disabled={loading} />
                <Input
                  name="password"
                  icon={FiLock}
                  subicon={showpass ? FiEye : FiEyeOff}
                  type={showpass ? 'text' : 'password'}
                  placeholder="Senha"
                  disabled={loading}
                  handleclick={showPassword}
                />
                <Button loading={loading} type="submit">
                  Entrar
                </Button>
              </section>
              <div>
                <Link to={`/registrar`}>
                  <span>Registre-se</span>
                </Link>
                <Link to={`/esqueci-minha-senha`}>
                  <span>Esqueci minha senha</span>
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </S.Container>
  );
};

export default Login;
